export default httpClient => ({
  save: async ({ nome, nome_conselho, status, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/especialidades-profissionais', {
      nome, nome_conselho, status
    }, { headers });
    return {
      data: response.data
    }
  },
  update: async ({ id, nome, nome_conselho, status, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", }
    const response = await httpClient.put('/especialidades-profissionais/' + id, {
      nome, nome_conselho, status
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/especialidades-profissionais/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/especialidades-profissionais', { headers });
    return {
      data: response.data
    }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/especialidades-profissionais/' + id, { headers });
    return {
      data: response
    }
  },
  deletarImagem: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
    return {
      data: response
    }
  },
});